<template>
  <div class="container-fluid">
    <notifications :duration="5000" />
    <ImageVerificationHeader v-model="isActive" :duration="localDuration" :count="localCount" />
    <ImageVerificationActive v-if="isActive" @verified="increaseStats" />
    <ImageVerificationInactive v-else />
  </div>
</template>

<script>
import ImageVerificationHeader from './ImageVerificationHeader.vue';
import ImageVerificationActive from './ImageVerificationActive.vue';
import ImageVerificationInactive from './ImageVerificationInactive.vue';
import RuleModal from './RulesModal.vue';

export default {
  name: 'ImageVerification',
  components: { RuleModal, ImageVerificationInactive, ImageVerificationActive, ImageVerificationHeader },
  props: {
    count: {
      type: [String, Number],
      required: true,
    },
    duration: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      localCount: 0,
      localDuration: 0,
      isActive: false,
    };
  },
  computed: {},
  methods: {
    increaseStats(currentDuration) {
      this.localDuration = (this.localCount * this.localDuration + currentDuration) / (Number(this.localCount) + 1);
      this.localCount++;
    },
  },
  mounted() {
    this.localCount = this.count;
    this.localDuration = this.duration;
  }
};
</script>

<style scoped>
</style>